import { AddressAnchor, AddressVersion } from 'src/models/anchor-and-version/address.model';
import { Component } from '@angular/core';
import { CrudBaseModalComponent } from '../crud-base-modal/crud-base-modal.component';
import { CrudModalAbstractComponent } from '../crud-base-modal/crud-modal-abstract.component';
import { ModalProps } from '../crud-base-modal/modal-field.interface';
import { hexAddressValidator } from 'src/validators/hex-address.validator';

@Component({
    selector: 'app-crud-address-modal',
    template: `<app-crud-base-modal #baseModal [modalProps]="modalProps"></app-crud-base-modal>`,
    imports: [CrudBaseModalComponent],
})
export class CrudAddressModalComponent extends CrudModalAbstractComponent<
    AddressAnchor,
    AddressVersion
> {
    public modalProps: ModalProps = {
        title: 'Address',
        validateNameFormat: true,
        anchorFields: [],
        versionFields: [
            {
                field: 'changeRequestKey',
                label: 'Change Request',
                type: 'lazy-dropdown',
                required: true,
                order: 1,
            },
            {
                field: 'address',
                label: 'Address',
                type: 'mask',
                mask: '0x**',
                placeholder: '0x__',
                required: true,
                order: 2,
                validator: hexAddressValidator,
            },
            { field: 'name', label: 'Name', type: 'text', required: true, order: 3 },
            { field: 'fullName', label: 'Full Name', type: 'text', order: 4 },
            { field: 'comment', label: 'Comment', type: 'textarea', order: 5 },
        ],
    };
}
